/**
 * @generated SignedSource<<8c64c8de662e7f76498596bacc237a46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppDialogImageAndTextTypePreviewItem_appDialog$data = {
  readonly appDialogBody: string | null;
  readonly appDialogButton: string | null;
  readonly appDialogImage: {
    readonly id: string;
    readonly objectUrl: string;
    readonly size: number;
  } | null;
  readonly appDialogTitle: string | null;
  readonly " $fragmentType": "AppDialogImageAndTextTypePreviewItem_appDialog";
};
export type AppDialogImageAndTextTypePreviewItem_appDialog$key = {
  readonly " $data"?: AppDialogImageAndTextTypePreviewItem_appDialog$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppDialogImageAndTextTypePreviewItem_appDialog">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppDialogImageAndTextTypePreviewItem_appDialog",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "appDialogImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "objectUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "appDialogButton",
      "storageKey": null
    }
  ],
  "type": "AppDialog",
  "abstractKey": null
};

(node as any).hash = "f8a453e4831e9da2f9ec761d8a6b6202";

export default node;
